
(function() {

    var tickAll = function($templateCache) {
        return {
            restrict: "EA",
            replace: true,
            transclude: true,
            template: $templateCache.get('components/listing/tickAll.html'),
            scope: true,
            bindToController: { // isolated scope
                /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
                ticked: "=",
                listingModel: "<",
                destroyData: "<",
                maxLimit: "<",
                tickedNumber: "="
            },
            controllerAs: 'ctrl',
            controller: ['$scope', '$element', '$attrs', '$transclude', function($scope, $element, $attrs, $transclude){
                // manual transclusion so it won't create unecessary additional element (html tag)!
                // $transclude(function(clone, scope) {
                //     // $element.append(clone);
                //     $element.find('input').after(clone.text());
                //     clone.remove();
                //     scope.$destroy(); // transclude scope (?)
                // });
            }],
            require: 'tickAll',
            link: function(scope, element, attrs, ctrl) {
                if (!ctrl.maxLimit){
                    ctrl.maxLimit = 200;
                }
                if (!ctrl.destroyData){
                    ctrl.destroyData = false;
                }
                if (!ctrl.tickedNumber){
                    ctrl.tickedNumber = '';
                }
                /**
                 * Loops through all the values in ticked and counts the number of true values.
                 * Warning: Since .ticked contains all checkboxes viewed this can start to become a large array/object
                 */

                var calculateTickedNumber = function(){
                    ctrl.tickedNumber = 0;
                    // tickedNumber is only required if preserving checkboxes check values across pages
                    if (ctrl.destroyData === false && ctrl.maxLimit) {
                        // counting number of ticked checkboxes
                        angular.forEach(ctrl.ticked, function (val, key) {
                            if (val === true) {
                                ctrl.tickedNumber++;
                            }
                        });
                    }
                };


                scope.onCheck = function() {

                    var orderedTickallIds = getListOfOrderedIds();

                    // Calculating amount of ticks left to tick and checking if amount of checkboxes unticked would go over the max limit is ticked all
                    if (ctrl.destroyData === false) {

                        // setting initial values for onCheck() function
                        scope.checkboxesOnPage = 0;
                        scope.tickedOnPageNumber = 0;
                        calculateTickedNumber();

                        // counting number of checkboxes on page and ticked checkboxes on page
                        orderedTickallIds.forEach(function(orderedTickAllId){
                            scope.checkboxesOnPage++;
                            if (ctrl.ticked[orderedTickAllId] == true) {
                                    scope.tickedOnPageNumber++;
                                }
                            });

                        // amount left to tick
                        scope.amountLeftToTick = ctrl.maxLimit - ctrl.tickedNumber;
                    }

                    // Limiting the amount of checboxes to tick based on the amount of theckboxes left to tick before rearching the max limit
                    var i = 0;
                    angular.forEach(orderedTickallIds, function(orderedTickAllId) {
                        // unticking all the checkboxes if no more checkboxes left to click on the page
                        if (scope.amountLeftToTick == 0 || scope.tickedOnPageNumber == scope.checkboxesOnPage){
                            angular.forEach(ctrl.ticked, function(val, key) {
                                if(orderedTickAllId == key) {
                                    ctrl.ticked[key] = false;
                                }
                            });
                            // setting tickall checkbox unticked
                            scope.checked = false;
                        // ticking the checkboxes if there's more left to tick
                        }else {
                            angular.forEach(ctrl.ticked, function(val, key) {
                                if(orderedTickAllId == key){
                                    if (ctrl.destroyData === false && i < scope.amountLeftToTick && !ctrl.ticked[key]) {
                                        ctrl.ticked[key] = true;
                                        i++;
                                    }
                                }
                            });
                            // setting tickall checkbox ticked
                            scope.checked = true;
                        }
                    });
                };

                scope.$watch(
                    function(){
                        return {
                            'tickall' : ctrl.ticked,
                            'refresh': ctrl.listingModel ? ctrl.listingModel.tilesData : true
                        }
                    },
                    function(newVal, oldVal){
                        calculateTickedNumber();
                        const orderedTickallIds = getListOfOrderedIds();
                        // false when no on screen multiaction-checkbox, true when on screen multiaction-checkbox and then eval each
                        var allTrue = (orderedTickallIds.length>0);
                        if(ctrl.ticked) {
                            for (var i = 0; i < orderedTickallIds.length; i++) {
                                if (ctrl.ticked[orderedTickallIds[i]] === false) {
                                    allTrue = false;
                                    break;
                                }
                            }
                        }
                        scope.checked = allTrue;
                    },
                    true // mind true argument - for "deep" change watch (array watch)
                );

                // Watching for filter change to erase the tickall objects
                if (ctrl.destroyData === false && ctrl.listingModel) {
                    scope.$watch(
                        function () {
                            return {
                                'sort': ctrl.listingModel.sort,
                                'order': ctrl.listingModel.order,
                                'resultsPerPage': ctrl.listingModel.resultsPerPage,
                                'filters': trueOnly(ctrl.listingModel.filters), //(ctrl.listingModel.filters!==undefined) ? _.pick( ctrl.listingModel.filters, function(value, key, object) {return value;}) : '',
                                'refresh': ctrl.listingModel.refresh,
                                'viewedBy': ctrl.listingModel.viewedBy,
                                'viewedWithinRefresh': ctrl.listingModel.viewedWithinRefresh,
                                'viewedWithinFrom': ctrl.listingModel.viewedWithinFrom,
                                'viewedWithinTo': ctrl.listingModel.viewedWithinTo,
                                'keywordFilter': ctrl.listingModel.keywordFilter,
                                'lockToMyOu': ctrl.listingModel.lockToMyOu,
                                'favouritesOnly': ctrl.listingModel.favouritesOnly,
                                'radius': ctrl.listingModel.radius
                            }
                        },
                        function (newVal, oldVal) {
                            ctrl.ticked = {};
                        },
                        true // mind true argument - for "deep" change watch (array watch)
                    );
                }

                // TODO: replace with underscore _.pick function
                function trueOnly(obj){
                    var result = {};
                    angular.forEach(obj, function(val, key){
                        if(val===true || val==='true'){
                            result[key]=val;
                        }
                    });
                    return result;
                }

                function getListOfOrderedIds(){
                    // Creating ordered tick all ids array as reference for tickall function
                    let orderedTickallIds = [];
                    var multiactionCheckboxes = document.getElementsByClassName('multiaction-checkbox');
                    for (var i = 0; i < multiactionCheckboxes.length; i++){
                        orderedTickallIds.push(multiactionCheckboxes[i].getAttribute('unique-id'));
                    }
                    return orderedTickallIds;
                }
            }
        };
    };
    tickAll.$inject = ['$templateCache'];
    angular.module('app').directive('tickAll', tickAll);

}());